var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowQrCodePvr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "#FFFDF5",
    stroke: "#FFCB05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0087 24.625C34.0087 19.8692 29.9674 16 25 16C20.0326 16 15.9913 19.8692 15.9913 24.625C15.9913 24.7507 15.9947 24.8756 16.0004 25C15.9947 25.1244 15.9913 25.2493 15.9913 25.375C15.9913 25.447 15.9923 25.519 15.9942 25.5906C15.9942 25.5908 15.9942 25.5909 15.9942 25.591C16.1144 30.2474 20.108 34 25 34C29.9674 34 34.0087 30.1308 34.0087 25.375C34.0087 25.2493 34.0052 25.1244 33.9997 25C34.0052 24.8756 34.0087 24.7507 34.0087 24.625Z",
    fill: "#0B0B0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 32.875C29.3264 32.875 32.8336 29.5171 32.8336 25.375C32.8336 21.2329 29.3264 17.875 25 17.875C20.6736 17.875 17.1664 21.2329 17.1664 25.375C17.1664 29.5171 20.6736 32.875 25 32.875Z",
    fill: "#C23100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18.25C29.2609 18.25 32.7272 21.507 32.8311 25.5625C32.8327 25.5002 32.8336 25.4377 32.8336 25.375C32.8336 21.2329 29.3264 17.875 25 17.875C20.6736 17.875 17.1664 21.2329 17.1664 25.375C17.1664 25.4377 17.1673 25.5002 17.1689 25.5625C17.2728 21.507 20.7392 18.25 25 18.25Z",
    fill: "#FFCB05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17.875C29.1951 17.875 32.6198 21.0321 32.8239 25C32.8302 24.8758 32.8336 24.7508 32.8336 24.625C32.8336 20.4829 29.3264 17.125 25 17.125C20.6736 17.125 17.1664 20.4829 17.1664 24.625C17.1664 24.7508 17.1698 24.8758 17.1761 25C17.3802 21.0321 20.805 17.875 25 17.875Z",
    fill: "#4A4A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2371 23.4812L28.381 21.625L22.0169 27.9888L23.873 29.845L30.2371 23.4812Z",
    fill: "#4A4A4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8734 29.845L25.7295 27.9888L21.6193 23.8788L19.7632 25.735L23.8734 29.845Z",
    fill: "#4A4A4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2371 23.1062L28.381 21.25L22.0169 27.6138L23.873 29.47L30.2371 23.1062Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8734 29.47L25.7295 27.6138L21.6193 23.5038L19.7632 25.36L23.8734 29.47Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowQrCodePvr);
export default __webpack_public_path__ + "static/media/show-qr-code-pvr.cdb793307d3b0e35db8132360bc3e92b.svg";
export { ForwardRef as ReactComponent };